import { useState } from 'react';
import { useLocation } from 'wouter';
import { Slider } from '../components/ui/slider';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Button } from '../components/ui/button';

export default function FiltersPage({ filters, setFilters, clearFilters, applyFilters, activeFilterTab }: any) {
  const [location, setLocation] = useLocation();
  // Local state for filters (could use context or props in real app)
  const [localFilters, setLocalFilters] = useState(filters || {
    priceRange: [0, 2000000],
    beds: null,
    baths: null,
    propertyType: null,
  });

  const handleChange = (key: string, value: any) => {
    setLocalFilters((prev: any) => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    if (setFilters) setFilters(localFilters);
    if (applyFilters) applyFilters(localFilters);
    setLocation('/');
  };

  const handleClear = () => {
    setLocalFilters({ priceRange: [0, 2000000], beds: null, baths: null, propertyType: null });
    if (clearFilters) clearFilters();
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex items-center justify-between px-4 py-4 border-b">
        <h2 className="text-xl font-bold">Filters</h2>
        <Button variant="ghost" onClick={() => setLocation('/')}>Close</Button>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-6 flex flex-col gap-6">
        {/* Price Range */}
        {activeFilterTab !== 'rent' && (
          <div>
            <label className="text-sm font-semibold mb-2 block">Price Range</label>
            <Slider
              value={localFilters.priceRange}
              onValueChange={(value) => handleChange('priceRange', value)}
              min={0}
              max={2000000}
              step={10000}
              className="mb-2"
            />
            <div className="flex justify-between text-xs text-gray-600 font-medium">
                              <span>${localFilters.priceRange[0] != null && typeof localFilters.priceRange[0] === 'number' ? localFilters.priceRange[0].toLocaleString() : ''}</span>
                <span>${localFilters.priceRange[1] != null && typeof localFilters.priceRange[1] === 'number' ? localFilters.priceRange[1].toLocaleString() : ''}</span>
            </div>
          </div>
        )}
        {/* Beds */}
        <div>
          <label className="text-sm font-semibold mb-2 block">Bedrooms</label>
          <Select
            value={localFilters.beds?.toString() || 'any'}
            onValueChange={(value) => handleChange('beds', value === 'any' ? null : parseInt(value))}
          >
            <SelectTrigger className="w-full h-12 rounded-lg border border-gray-200 bg-white shadow-sm focus:ring-2 focus:ring-blue-200">
              <SelectValue placeholder="Any" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="any">Any</SelectItem>
              <SelectItem value="1">1+</SelectItem>
              <SelectItem value="2">2+</SelectItem>
              <SelectItem value="3">3+</SelectItem>
              <SelectItem value="4">4+</SelectItem>
              <SelectItem value="5">5+</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {/* Baths */}
        <div>
          <label className="text-sm font-semibold mb-2 block">Bathrooms</label>
          <Select
            value={localFilters.baths?.toString() || 'any'}
            onValueChange={(value) => handleChange('baths', value === 'any' ? null : parseInt(value))}
          >
            <SelectTrigger className="w-full h-12 rounded-lg border border-gray-200 bg-white shadow-sm focus:ring-2 focus:ring-blue-200">
              <SelectValue placeholder="Any" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="any">Any</SelectItem>
              <SelectItem value="1">1+</SelectItem>
              <SelectItem value="2">2+</SelectItem>
              <SelectItem value="3">3+</SelectItem>
              <SelectItem value="4">4+</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {/* Property Type */}
        <div>
          <label className="text-sm font-semibold mb-2 block">Property Type</label>
          <Select
            value={localFilters.propertyType || 'any'}
            onValueChange={(value) => handleChange('propertyType', value === 'any' ? null : value)}
          >
            <SelectTrigger className="w-full h-12 rounded-lg border border-gray-200 bg-white shadow-sm focus:ring-2 focus:ring-blue-200">
              <SelectValue placeholder="Any" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="any">Any</SelectItem>
              <SelectItem value="Single Family">Single Family</SelectItem>
              <SelectItem value="Condo">Condo</SelectItem>
              <SelectItem value="Townhouse">Townhouse</SelectItem>
              <SelectItem value="Multi Family">Multi Family</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {/* Add more advanced filters here as needed */}
      </div>
      <div className="sticky bottom-0 bg-white border-t flex gap-2 p-4">
        <Button variant="outline" className="flex-1" onClick={handleClear}>Clear All</Button>
        <Button className="flex-1" onClick={handleApply}>Apply Filters</Button>
      </div>
    </div>
  );
} 